import { render, staticRenderFns } from "./CCMMedicationEvent.vue?vue&type=template&id=5b1ec5a4"
import script from "./CCMMedicationEvent.vue?vue&type=script&lang=js"
export * from "./CCMMedicationEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports